//
// Module for the Fund Account Correspondence Review Index view
//
rs.module("content/fund/account/correspondencereview/index",

    [
        "common/select-helper"
    ],

    function (selectHelper) {

        // Initialize the module
        function initialize(jsSelectors, individualType) {

            // Unpack filter js selectors
            var formFilter = $.js(jsSelectors.formFilter);

            var correspondenceSelect = formFilter.js(jsSelectors.correspondenceSelect);
            var recipientSelect = formFilter.js(jsSelectors.recipientSelect);
            var includeAllCheckbox = formFilter.js(jsSelectors.includeAllCheckbox);

            // Get Select Helper(s)
            var recipientSelectHelper = selectHelper.getHelper(recipientSelect);

            // On correspondence type change availability of recipient select
            correspondenceSelect.change(function () {

                if (correspondenceSelect.val() == individualType) {
                    recipientSelectHelper.removeEmptyOption().setDisabled(false);

                    includeAllCheckbox.prop('disabled', true).prop('checked', false);
                }
                else {
                    recipientSelectHelper.addEmptyOption().setValue('').setDisabled(true);

                    includeAllCheckbox.prop('disabled', false);
				}
			});
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);